
export const THEME_COLOR = '#F3913D';   // #F3913D or #30217F

export const HOST = (window.location.hostname === 'localhost')? 'https://dev.larynx.ai' : window.location.origin;